var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BtnToggle',{staticClass:"btn-tool-font-awesome",attrs:{"title":'Font Awesome'},on:{"click":_vm.chooseFontAwesome}},[_c('i',{staticClass:"mce-ico mce-i-font-awesome-o"})])}
var staticRenderFns = []

export { render, staticRenderFns }